import gql from 'graphql-tag'

export const Q_GET_TEAMS = gql`
query ($where:ListWhere) {
  teams (where:$where) {
    id
    name
    code
    schedules
  }
}`

export const M_ADD_TEAM = gql`mutation ($code:String!, $name:String!, $schedules:JSON) {
  createTeam (code:$code, name:$name, schedules:$schedules)
  {
    id
  code
  name
  schedules
  }
}`

export const M_UPDATE_TEAM = gql`mutation ($id:Int!, $code:String, $name:String, $schedules:JSON) {
  updateTeam (id:$id, code:$code, name:$name, schedules:$schedules)
  {
    id
 code
 name
 schedules
  }
}`

export const M_CREATE_MANY_TEAMS = gql`mutation($records:[TeamInput]!) {
  createTeams(records:$records) {
    id
  code
  name
  schedules
  }
}`

export const M_DELETE_TEAM = gql`mutation($where:ListWhere!) {
  deleteTeam(where:$where)
}`
